export const enum RecoSliderPosition {
  Default,
  Drawer,
}
